<ng-container *ngIf="ready">

  <div class="butonera">
    <button type="button" (click)="createUser()" mat-stroked-button class="btn btn-warning btn-circle btn-lg fc-black p-0">
      <mat-icon class="mat-icon-add-custom">add</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="isBusinessGroup">
    <app-table [columns]="headerTableConsultant" [dataSource]="consultantList" [hasButton]="true"
      [actionsTemplate]="actionsButtons" [hasHeaderActions]="true" [headerActionsTemplate]="headerActionsButtons"
      [hasSelect]="true"></app-table>
  </ng-container>

  <ng-container *ngIf="isConsultant">

    <app-table [columns]="headerTableConsultant" [dataSource]="consultantList" [hasButton]="true"
      [actionsTemplate]="actionsButtons"></app-table>

  </ng-container>

  <!--acciones buttons header-->
  <ng-template #headerActionsButtons let-selected="selected">
    <ul class="custom-class">
      <li (click)="perdidasyganancias(selected)">
        <a>
          Excel Balance Perdidas y Ganancias
        </a>
      </li>
      <li (click)="balancepymes(selected)">
        <a>
          Excel Balance Pymes
        </a>
      </li>
      <li (click)="reports(selected)">
        <a>
          Excel Informes
        </a>
      </li>
      <li (click)="balancesumasysaldos(selected)">
        <a>
          Excel Balance Sumas y Saldos
        </a>
      </li>
    </ul>
  </ng-template>

  <ng-template #actionsButtons let-uid="uid">
    <ng-container *ngFor="let row of (consultantList | filter : uid : 'uid'); trackBy: trackByIndex">
      <ul class="custom-class">
        <ng-container *ngIf="row.accepted">
          <li (click)="access(row.clientUid)">
            <a>
              <mat-icon>remove_red_eye</mat-icon> Acceder
            </a>
          </li>
        </ng-container>
        <ng-container *ngIf="!row.accepted">
          <li (click)="edit(uid)">
            <a>
              <mat-icon>done</mat-icon>Aceptar
            </a>
          </li>
        </ng-container>

        <li (click)="delete(uid)">
          <a>
            <mat-icon>warning</mat-icon> Borrar
          </a>
        </li>
      </ul>
    </ng-container>
  </ng-template>
</ng-container>

<ng-container *ngIf="!ready">
  <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
</ng-container>
